export enum UserSessionStatus {
    REVOKED,
    RIGHTS_CHANGED
}
